import { MenuOption } from "@/components/layout/Header/UserMenu/types";
import { IS_LOCALLY, IS_STAGING } from ".";

export const USER_MENU_MAIN_OPTIONS: MenuOption[] = [
  {
    name: "Projects",
    to: "/",
    icon: "pen",
    visible: IS_STAGING || IS_LOCALLY,
  },
  {
    name: "Add a project",
    to: "/project-builder",
    icon: "plus",
    visible: true,
  },
];

export const FOOTER_LINKS = [
  {
    text: "Privacy Policy",
    href: "https://www.thrive.xyz/privacy-policy",
    external: true,
    description: "Learn how we protect your privacy and handle your data",
  },
  {
    text: "Terms of Service",
    href: "https://www.thrive.xyz/terms-of-service",
    external: true,
    description: "Read our terms of service and user agreement",
  },
  {
    text: "Code of Conduct",
    href: "https://www.thrive.xyz/code-of-conduct",
    external: true,
    description: "Our community guidelines and code of conduct",
  },
];
